import {
    USERS_LOADING,
    USERS_ERROR,

    USERS_GET_LIST,
    USERS_GET_FILTERS,
    USERS_GET_SINGLE,
    USERS_UPDATE_SINGLE,
    USERS_UPDATE_PACKAGE,
    USERS_UPDATE_TARIFF
} from "actions/users/constants";
import moment from "moment";

const initialState = {
    loading: false,
    errors: [],

    usersList: [],
    usersFilters: [],
    userSingle: {},
    usersTotalCount: 0
};

export default function(state = initialState, action) {
    let index,
        usersList,
        userSingle;
    switch (action.type) {
        case USERS_LOADING:
            return {
                ...state,
                loading: action.payload.content
            };
        case USERS_ERROR:
            return {
                ...state,
                loading: false,
                errors: action.payload.content
            };
        case USERS_GET_LIST:
            return {
                ...state,
                loading: false,
                errors: [],
                usersList: action.payload,
                usersTotalCount: state.usersTotalCount === 0 ? action.payload.total_count : state.usersTotalCount
            };
        case USERS_GET_FILTERS:
            return {
                ...state,
                loading: false,
                errors: [],
                usersFilters: action.payload,
            };
        case USERS_GET_SINGLE:
            return {
                ...state,
                loading: false,
                errors: [],
                userSingle: action.payload,
            };
        case USERS_UPDATE_SINGLE:
            usersList = Object.assign([], state.usersList);
            if (usersList.length && usersList.content && Array.isArray(usersList.content)) {
                usersList.content = Object.assign([], usersList.content);
                index = usersList.content.findIndex(value => value.id === action.payload.id);
                if (index > -1) {
                    usersList.content[index] = action.payload;
                }
            }
            userSingle = Object.assign({}, state.userSingle);
            if (Object.keys(userSingle).length
                && userSingle.id
                && userSingle.id === action.payload.id) {
                userSingle = action.payload;
            }
            return {
                ...state,
                loading: false,
                errors: [],
                usersList,
                userSingle,
            };
        case USERS_UPDATE_PACKAGE:
            usersList = Object.assign([], state.usersList);
            index = usersList.findIndex(item => item.id === action.payload.userId);
            if (index > -1) {
                usersList[index] = Object.assign({}, usersList[index]);
                usersList[index].activePackage = action.payload.package;
            }

            userSingle = Object.assign({}, state.userSingle);
            if (userSingle.id === action.payload.userId) {
                userSingle.activePackage = action.payload.package;
            }
            return {
                ...state,
                usersList,
                userSingle
            };
        case USERS_UPDATE_TARIFF:
            // endDate: 1594929599999
            // id: "5ecfff4b8882722df0876787"
            // name: "test"
            // startDate: 1594139404430
            usersList = Object.assign([], state.usersList);
            index = usersList.findIndex(item => item.id === action.payload.userId);
            if (index > -1) {
                usersList[index] = Object.assign({}, usersList[index]);
                usersList[index].activeTariff = {
                    ...action.payload.tariff,
                    startDate: moment().valueOf(),
                    endDate: action.payload.content.until,
                };
            }

            userSingle = Object.assign({}, state.userSingle);
            if (userSingle.id === action.payload.userId) {
                userSingle.activeTariff = {
                    ...action.payload.tariff,
                    startDate: moment().valueOf(),
                    endDate: action.payload.content.until,
                };
            }
            return {
                ...state,
                usersList,
                userSingle
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/usersReducer.js